import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { SubService } from 'src/app/services/sub.service';
import { BeVeiculo } from 'src/app/models/BeVeiculo';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-edit-veiculo',
  templateUrl: './edit-veiculo.component.html',
  styleUrls: ['./edit-veiculo.component.css']
})
export class EditVeiculoComponent implements OnInit, OnDestroy {
  public idVeiculo?: number;
  public veiculo?: BeVeiculo;
  public subscription?: Subscription;
  public editFormGroup: FormGroup;

  private editIdVeiculoFormControl = new FormControl<number | null>(null, [Validators.required]);
  private editDsMarcaFormControl = new FormControl<string>("", [Validators.required, Validators.minLength(2)]);
  private editDsModeloFormControl = new FormControl<string>("", [Validators.required, Validators.minLength(2)]);
  private editDsCorFormControl = new FormControl<string>("", [Validators.required, Validators.minLength(3)]);
  private editDsAnoFabricacaoFormControl = new FormControl<string>("", [Validators.required, Validators.minLength(4)]);
  private editDsAnoModeloFormControl = new FormControl<string>("", [Validators.required, Validators.minLength(4)]);
  private editDsPlacaFormControl = new FormControl<string>("", [Validators.required, Validators.minLength(7)]);

  public constructor(
    private httpClient: HttpClient,
    private route: ActivatedRoute,
    private sub: SubService,
    private router: Router,
    private snackBarService: SnackBarService,
  ) {
    this.editFormGroup = new FormGroup({
      idVeiculo: this.editIdVeiculoFormControl,
      dsMarca: this.editDsMarcaFormControl,
      dsModelo: this.editDsModeloFormControl,
      dsCor: this.editDsCorFormControl,
      dsAnoFabricacao: this.editDsAnoFabricacaoFormControl,
      dsAnoModelo: this.editDsAnoModeloFormControl,
      dsPlaca: this.editDsPlacaFormControl,
    });
  }

  public ngOnInit(): void {
    this.sub.clear();
    this.idVeiculo = Number(this.route.snapshot.paramMap.get('id'));
    if (this.idVeiculo) {
      this.subscription = this.httpClient.get<BeVeiculo>(`/api/Veiculos/${this.idVeiculo}`).subscribe(veiculo => {
        if (!veiculo || !veiculo.idVeiculo) {
          this.unsubscribe();
          this.snackBarService.exibirErro('Nenhum veículo encontrado')
          this.router.navigate(['/veiculos'], { relativeTo: this.route });
          return;
        }
        this.editIdVeiculoFormControl.setValue(veiculo.idVeiculo);
        this.editDsMarcaFormControl.setValue(veiculo.dsMarca);
        this.editDsModeloFormControl.setValue(veiculo.dsModelo);
        this.editDsCorFormControl.setValue(veiculo.dsCor);
        this.editDsAnoFabricacaoFormControl.setValue(veiculo.dsAnoFabricacao);
        this.editDsAnoModeloFormControl.setValue(veiculo.dsAnoModelo);
        this.editDsPlacaFormControl.setValue(veiculo.dsPlaca);
        this.veiculo = veiculo;
        this.unsubscribe();
      });
    }
  }

  public ngOnDestroy(): void {
    this.sub.clear();
    this.unsubscribe();
  }

  public onSalvar() {
    this.unsubscribe();
    this.subscription = this.httpClient.put<unknown>(
      `/api/Veiculos`, this.editFormGroup.value
    ).subscribe({
      next: () => {
        this.unsubscribe();
        this.snackBarService.exibirSucesso('Registro salvo!');
        this.router.navigate(['/veiculos'], { relativeTo: this.route });
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }

  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }
}